import React, { useState } from "react";
import { toast } from "react-toastify";
import adminPricingService from "./adminPricingService";

const AddFeatureModal = ({ onClose, onSuccess }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleAdd = async () => {
    if (!name.trim() || !description.trim()) {
      toast.error("Both name and description are required.");
      return;
    }

    const payload = { name, description };

    try {
      await adminPricingService.addFeature(payload);
      toast.success("Feature added successfully!");
      onSuccess();
      onClose();
    } catch (error) {
      console.error("Error adding feature:", error);
      toast.error("Failed to add feature.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg relative">
        <h2 className="text-xl font-bold mb-4">Add Feature</h2>

        <input
          className="w-full mb-3 p-2 border rounded"
          type="text"
          placeholder="Feature Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <textarea
          className="w-full mb-4 p-2 border rounded"
          placeholder="Feature Description"
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleAdd}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddFeatureModal;
